import dotRankActiveImg from '@assets/web-v3-images/dot-rank-active.png';
import dotRankImg from '@assets/web-v3-images/dot-rank.png';
import progressRankImg from '@assets/web-v3-images/progress-rank.png';
import progressRankActiveImg from '@assets/web-v3-images/progressRank-active.png';
import { useTranslation } from 'react-i18next';

const NODE_WIDTH_PX = 44;
const TRACK_PADDING_PX = 4;

export default function DayStreakProgress({ currentDay = 1, totalDays = 7 }) {
	const { t } = useTranslation()
	const nodes = Array.from({ length: totalDays }, (_, i) => i + 1);

	// frac = tỉ lệ vị trí node active trong dãy justify-between (0 -> 1)
	const frac =
		totalDays > 1 ? (currentDay - 1) / (totalDays - 1) : currentDay > 0 ? 1 : 0;

	const percentPart = frac * 100;
	const pxPart =
		NODE_WIDTH_PX - frac * (2 * TRACK_PADDING_PX + NODE_WIDTH_PX);

	const fillWidthPercent =
		currentDay > 0
			? `calc(${percentPart}% + ${pxPart}px)`
			: "0%";

	return (
		<div className="flex items-center justify-center w-full">
			<div className="w-full">
				<div
					className="relative flex items-center justify-between h-5 sm:h-8 rounded-full"
					style={{
						backgroundImage: `url(${progressRankImg})`,
						backgroundSize: "100% 100%",
						backgroundRepeat: "no-repeat",
						boxShadow:
							"inset 0 2px 3px rgba(255,255,255,0.5), inset 0 -2px 4px rgba(150,30,0,0.35)",
					}}
				>
					<div
						className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full transition-[width] duration-500 ease-out h-3 sm:h-5"
						style={{
							width: fillWidthPercent,
							backgroundImage: `url(${progressRankActiveImg})`,
							backgroundSize: "100% 100%",
							backgroundRepeat: "no-repeat",
							boxShadow:
								"inset 0 2px 3px rgba(255,255,255,0.6), inset 0 -2px 3px rgba(180,110,0,0.25)",
						}}
					/>

					{nodes.map((day) => {
						const isFilled = day <= currentDay;
						const isCurrent = day === currentDay;

						return (
							<div key={day} className="relative z-10 shrink-0">
								<img
									src={isFilled ? dotRankActiveImg : dotRankImg}
									alt={`Day ${day}`}
									className="w-6 sm:w-11 object-contain select-none pointer-events-none"
									draggable={false}
								/>

								{isCurrent && (
									<span
										className="absolute left-1/2 -translate-x-1/2 top-[calc(100%+20px)] whitespace-nowrap font-bold text-[11px] sm:text-[19px] px-4 py-1.5 sm:py-2.5 rounded-3xl"
										style={{
											background: "linear-gradient(180deg, rgb(255, 245, 210), rgb(255, 226, 137))",
											color: "#7a3b00",
											boxShadow: "0 3px 6px rgba(140,70,0,0.3)",
										}}
									>
										{t("rank.day")} {currentDay}/{totalDays}
										<span
											className="absolute left-1/2 -translate-x-1/2 -top-3.5 w-3.5 h-3.5"
											style={{
												background: "linear-gradient(180deg, rgb(255, 245, 210), rgb(255, 245, 210))",
												clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
											}}
										/>
									</span>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}